import { useAuth } from "@/app/providers";
import { AlertEscalationPolicyPage } from "@/pages/AlertEscalationPolicyPage";
import { AlertHistoryPage } from "@/pages/AlertHistoryPage";
import { LoginPage } from "@/pages/LoginPage";
import { ManageMembersPage } from "@/pages/ManageMembersPage";
import { ManageTeamsPage } from "@/pages/ManageTeamsPage";
import { ManualAlertTriggerPage } from "@/pages/ManualAlertTriggerPage";
import { OncallOverviewPage } from "@/pages/OncallOverviewPage";
import { OncallSchedulePage } from "@/pages/OncallSchedulePage";
import { SettingsPage } from "@/pages/SettingsPage";
import { FullPageLoading } from "@/shared/components/feedback";
import { AppLayout } from "@/shared/components/layout/AppLayout";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <FullPageLoading />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return <>{children}</>;
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <FullPageLoading />;
  if (isAuthenticated) return <Navigate to="/overview" replace />;

  return <>{children}</>;
}

export function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />

        {/* Protected with layout */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/overview" replace />} />
          <Route path="overview"                element={<OncallOverviewPage />} />
          <Route path="alert/trigger"           element={<ManualAlertTriggerPage />} />
          <Route path="schedule"                element={<OncallSchedulePage />} />
          <Route path="alert/escalation-policy" element={<AlertEscalationPolicyPage />} />
          <Route path="alert/history"           element={<AlertHistoryPage />} />
          {/* SPT-4066: 팀원 관리는 팀 관리로 통합 */}
          <Route path="team/members"            element={<Navigate to="/teams" replace />} />
          <Route path="members"                 element={<ManageMembersPage />} />
          <Route path="teams"                   element={<ManageTeamsPage />} />
          <Route path="settings"               element={<SettingsPage />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/overview" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
